// extracted by mini-css-extract-plugin
export default {"TutorInfoBox":"TutorInfo_TutorInfoBox__u5zoq","MailInfoBox":"TutorInfo_MailInfoBox__NYVhe"};